export const PROMOTION_STATES = {
	ALL: "All",
	ACTIVE: 1,
	FINISHED: 2
};

export const PROMOTION_TYPE = {
	DOUBLE_DOOBLE: 1,
};

export const PROMOTION_TYPE_TRANSLATION = {
	[PROMOTION_TYPE.DOUBLE_DOOBLE]: "promotion.doubleDooble",
};